import { LineEndingType } from "@evergis/api";

import { ArrowLineMiterRender } from "./ArrowLineMiterRender";
import { CircleLineMiterRender } from "./CircleLineMiterRender";
import { LineMiterRenderBaseInfo, LineMiterRender } from "./LineMiterRender";
import { NoneLineMiterRender } from "./NoneLineMiterRender";
import { SquareLineMiterRender } from "./SquareLineMiterRender";

export type LinerMiterRenderOptions = LineMiterRenderBaseInfo & {
  renderEmptyMiter?: boolean;
};

export const getLineMiterRender = (options: LinerMiterRenderOptions): LineMiterRender => {
  switch (options.kind) {
    case LineEndingType.Arrow:
    case LineEndingType.FilledArrow:
      return new ArrowLineMiterRender(options);
    case LineEndingType.Square:
    case LineEndingType.FilledSquare:
      return new SquareLineMiterRender(options);
    case LineEndingType.Circle:
    case LineEndingType.FilledCircle:
      return new CircleLineMiterRender(options);
    case LineEndingType.None:
      return options.renderEmptyMiter ? new NoneLineMiterRender(options) : null;
    default:
      return null;
  }
};
